import {useMutation, type UseMutationResult} from '@github-ui/react-query'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {fetchCAPI} from '@github-ui/agent-sessions/utils/fetch-capi'

export type CreateFixWorkflowJobRequest = {
  problemStatement: string
  branch: string
  prTitle: string
  eventType: string
}

export type CreateFixWorkflowJobResponse = {
  job_id: string
}

export type CreateFixWorkflowJobOptions = {
  owner: string
  repo: string
  onSuccess?: (data: CreateFixWorkflowJobResponse) => void
  onError?: (error: Error) => void
}

export function useCreateFixWorkflowJob({
  owner,
  repo,
  onSuccess,
  onError,
}: CreateFixWorkflowJobOptions): UseMutationResult<CreateFixWorkflowJobResponse, Error, CreateFixWorkflowJobRequest> {
  const createJob = useMutation({
    mutationFn: async (request: CreateFixWorkflowJobRequest) => {
      const path = `/agents/swe/v1/jobs/${owner}/${repo}`
      const response = await fetchCAPI({
        path,
        method: 'POST',
        body: {
          problem_statement: request.problemStatement,
          pull_request: {
            base_ref: `refs/heads/${request.branch}`,
            title: request.prTitle,
          },
          event_type: request.eventType,
        },
      })

      const body = await response.json()
      return body as CreateFixWorkflowJobResponse
    },
    onSuccess,
    onError,
  })

  return createJob
}
